var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label != null && _vm.label !== '')?_c('div',{staticClass:"displayLabel"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{class:_vm.bodyCss},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }